__turbopack_context__.v({
  "modalContent": "ConnectionShareModal-module__WluqqG__modalContent",
  "pendingRemovalWarning": "ConnectionShareModal-module__WluqqG__pendingRemovalWarning",
  "typeahead": "ConnectionShareModal-module__WluqqG__typeahead",
});
